import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function ai_chat() {


    return (
        <>
            <Header />
            <div class="ai-ifm-div">
                <div class="ai-ifm-div-sub">
                <iframe src="https://open-webui-995224459939.asia-southeast1.run.app/"  height="800" class="relative w-full overflow-hidden" allow="fullscreen; clipboard-write; autoplay" ></iframe>
                </div>
            </div>
            <Footer />
        </>
    );
}
